//──── Appointment ───────────────────────────────────────────────────────────────────────
export const CLEAR_APPOINTMENT = 'CLEAR_APPOINTMENT';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const LOAD_APPOINTMENT_BY_ID_SUCCESS = 'LOAD_APPOINTMENT_BY_ID_SUCCESS';
export const LOAD_APPOINTMENT_BY_ID_ERROR = 'LOAD_APPOINTMENT_BY_ID_ERROR';

//──── Active appointment ────────────────────────────────────────────────────────────────
export const ADD_ACTIVE_APPOINTMENT = 'ADD_ACTIVE_APPOINTMENT';
export const REMOVE_ACTIVE_APPOINTMENT = 'REMOVE_ACTIVE_APPOINTMENT';
export const UPDATE_ACTIVE_APPOINTMENT = 'UPDATE_ACTIVE_APPOINTMENT';

//──── Patient ───────────────────────────────────────────────────────────────────────────
export const LOAD_PATIENT_SUCCESS = 'LOAD_PATIENT_SUCCESS';
export const LOAD_PATIENT_ERROR = 'LOAD_PATIENT_ERROR';
export const VERIFY_PATIENT_SUCCESS = 'VERIFY_PATIENT_SUCCESS';
export const VERIFY_PATIENT_ERROR = 'VERIFY_PATIENT_ERROR';
export const BLOCK_PATIENT_SUCCESS = 'BLOCK_PATIENT_SUCCESS';
export const BLOCK_PATIENT_ERROR = 'BLOCK_PATIENT_ERROR';
export const CLEAR_PATIENT = 'CLEAR_PATIENT';

//──── Invoice ───────────────────────────────────────────────────────────────────────────
export const CLEAR_INVOICE = 'CLEAR_INVOICE';
export const LOAD_INVOICE_SUCCESS = 'LOAD_INVOICE_SUCCESS';
export const LOAD_INVOICE_ERROR = 'LOAD_INVOICE_ERROR';
export const DELETE_INVOICE_SUCCESS = 'DELETE_INVOICE_SUCCESS';
export const DELETE_INVOICE_ERROR = 'DELETE_INVOICE_ERROR';
export const CONFIRM_PAYMENT_SUCCESS = 'CONFIRM_PAYMENT_SUCCESS';
export const CONFIRM_PAYMENT_ERROR = 'CONFIRM_PAYMENT_ERROR';

//──── Tabs ────────────────────────────────────────────────────────────────────────────
export const CHANGE_ACTIVE_TAB = 'CHANGE_ACTIVE_TAB';

//──── Workflow ──────────────────────────────────────────────────────────────────────────
export const CLEAR_TIMELINE = 'CLEAR_TIMELINE';
export const TRIGGER_WORKFLOW_SUCCESS = 'TRIGGER_WORKFLOW_SUCCESS';
export const TRIGGER_WORKFLOW_ERROR = 'TRIGGER_WORKFLOW_ERROR';
export const LOAD_WORKFLOW_TIMELINE_SUCCESS = 'LOAD_WORKFLOW_TIMELINE_SUCCESS';
export const LOAD_WORKFLOW_TIMELINE_ERROR = 'LOAD_WORKFLOW_TIMELINE_ERROR';
